import { Icon, IconNames, Table, Text } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { ampli } from 'lib-shared-tracking';
import type {
  FlowConversationChannel,
  ScheduleFlow,
} from 'lib-shared-types-api';
import { Link } from 'react-router-dom';

import { useTableHistory } from 'hooks/useTableHistory/useTableHistory';

import styles from './tableFlowRow.module.scss';

const flowAttributes: Record<
  FlowConversationChannel,
  { icon: IconNames; path: string }
> = {
  pstn_phone: {
    icon: 'phone',
    path: 'phone',
  },
  widget_chat: {
    icon: 'chat',
    path: 'chat',
  },
  email: {
    icon: 'mail',
    path: 'email',
  },
  messenger: {
    icon: 'messenger',
    path: 'dixa-messenger',
  },
};

function getIconName(channel: FlowConversationChannel): IconNames {
  return flowAttributes[channel].icon;
}

function getUrl(channel: FlowConversationChannel, flowId: string): string {
  const getFlowPath = () => flowAttributes[channel].path;

  return `/settings/${getFlowPath()}/flow/${flowId}`;
}

type Props = ScheduleFlow & {
  scheduleId: string;
};

export const TableFlowRow = ({
  scheduleId,
  active,
  channel,
  id,
  name,
}: Props): JSX.Element => {
  const isInvalid = !flowAttributes[channel];
  const { onToggle } = useTableHistory();

  return (
    <Table.Tr className={styles.root} key={id}>
      <Table.Td
        className={classnames(styles.name, {
          [styles.nameIsActive]: !isInvalid && active,
        })}
      >
        {isInvalid ? (
          <Text.Paragraph className={styles.flowName}>
            Invalid flow data
          </Text.Paragraph>
        ) : (
          <>
            <Icon className={styles.icon} name={getIconName(channel)} />
            <Text.Paragraph className={styles.flowName}>{name}</Text.Paragraph>
            <Link
              className={styles.flowLink}
              onClick={() => {
                onToggle(scheduleId, true);
                ampli.businessHoursGoToFlowClicked();
              }}
              to={getUrl(channel, id)}
              state={{
                shouldGoBack: true,
                backButtonText: 'Back to business hours',
                goBackPath: '/settings/businesshours',
              }}
            >
              Go to flow
            </Link>
          </>
        )}
      </Table.Td>
    </Table.Tr>
  );
};
